/** Grid <-> world-space conversion. The maze lies flat on the XZ plane, Y is up.
 * The maze is centered on the origin so the isometric camera frames it naturally. */
import { TILE_SIZE } from '../constants/game-config'
import { getMazeDimensions } from '../data/maze-data'

const dims = getMazeDimensions()
export const MAZE_ROWS = dims.rows
export const MAZE_COLS = dims.cols

const ORIGIN_X = -((MAZE_COLS - 1) / 2) * TILE_SIZE
const ORIGIN_Z = -((MAZE_ROWS - 1) / 2) * TILE_SIZE

export function gridToWorld(col: number, row: number): { x: number; z: number } {
  return { x: ORIGIN_X + col * TILE_SIZE, z: ORIGIN_Z + row * TILE_SIZE }
}

export function worldToGrid(x: number, z: number): { col: number; row: number } {
  return {
    col: Math.round((x - ORIGIN_X) / TILE_SIZE),
    row: Math.round((z - ORIGIN_Z) / TILE_SIZE),
  }
}

/** Continuous (fractional) grid coordinate — useful for sub-cell interpolation. */
export function worldToGridF(x: number, z: number): { col: number; row: number } {
  return {
    col: (x - ORIGIN_X) / TILE_SIZE,
    row: (z - ORIGIN_Z) / TILE_SIZE,
  }
}

export const worldWidth = () => MAZE_COLS * TILE_SIZE
export const worldDepth = () => MAZE_ROWS * TILE_SIZE
